// AUTO-GENERATED from the legal source documents supplied by the client.
// Owner-instruction lines ("...before publication", "...review by counsel") were removed.
// Do not hand-edit: regenerate if the source documents change.

export type LegalLine = { t: "p" | "li" | "intro"; s: string };
export type LegalSection = { heading: string; lines: LegalLine[] };
export type LegalDoc = { title: string; effective: string; updated: string; sections: LegalSection[] };

export const privacyPolicy: LegalDoc = {
  title: "ResFil AI Privacy Policy",
  effective: "August 20, 2026",
  updated: "August 20, 2026",
  sections: [
    {
      heading: "Introduction",
      lines: [
        { t: "p", s: "Welcome to ResFil AI." },
        { t: "p", s: "This Privacy Policy describes how ResFil AI (“ResFil,” “we,” “us,” or “our”) collects, uses, processes, stores, and discloses information in connection with our websites, software, applications, artificial intelligence services, communication tools, and related products and services (collectively, the “Services”).ResFil provides an AI-powered customer communication and business automation platform designed to help businesses manage customer communications, leads, calls, text messages, appointments, scheduling, follow-up activities, customer relationships, and related business operations." },
        { t: "p", s: "Our Services may include AI-powered voice receptionists, AI chat and SMS communication, appointment scheduling, lead management, customer management, knowledge management, call processing, transcription, automated follow-up, customer reactivation, review-related workflows, analytics, dispatch-related functionality, integrations, and other business automation tools." },
        { t: "p", s: "This Privacy Policy applies to information we process through the ResFil platform and our public-facing websites." },
        { t: "p", s: "Businesses using ResFil may also maintain their own privacy policies governing their relationships with their customers. When you communicate with a business that uses ResFil, that business may separately be responsible for its own privacy practices and legal obligations." },
      ],
    },
    {
      heading: "Information We Collect",
      lines: [
        { t: "p", s: "Depending on how you interact with ResFil, we may collect the following categories of information." },
        { t: "li", s: "Account and Business Information" },
        { t: "intro", s: "When a business or authorized user creates or manages a ResFil account, we may collect:" },
        { t: "li", s: "Name" },
        { t: "li", s: "Business name" },
        { t: "li", s: "Email address" },
        { t: "li", s: "Telephone number" },
        { t: "li", s: "Business address" },
        { t: "li", s: "Business website" },
        { t: "li", s: "Industry" },
        { t: "li", s: "Business operating information" },
        { t: "li", s: "Account credentials" },
        { t: "li", s: "User role and permissions" },
        { t: "li", s: "Team-member information" },
        { t: "li", s: "Service information" },
        { t: "li", s: "Service areas" },
        { t: "li", s: "Business hours" },
        { t: "li", s: "Scheduling and availability information" },
        { t: "li", s: "Customer and Lead Information" },
        { t: "intro", s: "Businesses using ResFil may provide or generate information regarding their customers and prospective customers, including:" },
        { t: "li", s: "Names" },
        { t: "li", s: "Telephone numbers" },
        { t: "li", s: "Email addresses" },
        { t: "li", s: "Addresses" },
        { t: "li", s: "Customer inquiries" },
        { t: "li", s: "Lead information" },
        { t: "li", s: "Service requests" },
        { t: "li", s: "Appointment information" },
        { t: "li", s: "Communication history" },
        { t: "li", s: "Estimates or opportunity information" },
        { t: "li", s: "Customer status" },
        { t: "li", s: "Other information provided during customer interactions" },
        { t: "li", s: "Communications" },
        { t: "p", s: "When individuals communicate with ResFil or with a business using ResFil, we may process information associated with those communications." },
        { t: "intro", s: "This may include:" },
        { t: "li", s: "Telephone calls" },
        { t: "li", s: "SMS/text messages" },
        { t: "li", s: "Chat messages" },
        { t: "li", s: "Customer inquiries" },
        { t: "li", s: "Appointment requests" },
        { t: "li", s: "Customer support communications" },
        { t: "li", s: "Call metadata" },
        { t: "li", s: "Message metadata" },
        { t: "li", s: "Communication timestamps" },
        { t: "li", s: "Call recordings where enabled and legally permitted" },
        { t: "li", s: "Call transcripts" },
        { t: "li", s: "AI-generated summaries" },
        { t: "li", s: "AI-generated classifications or other communication-related information" },
        { t: "li", s: "Scheduling Information" },
        { t: "intro", s: "ResFil may process scheduling-related information such as:" },
        { t: "li", s: "Requested services" },
        { t: "li", s: "Appointment dates and times" },
        { t: "li", s: "Availability" },
        { t: "li", s: "Appointment duration" },
        { t: "li", s: "Assigned team members or technicians" },
        { t: "li", s: "Appointment status" },
        { t: "li", s: "Service location" },
        { t: "li", s: "Rescheduling and cancellation information" },
        { t: "li", s: "Reminder and confirmation information" },
        { t: "li", s: "Payment Information" },
        { t: "intro", s: "If payments are processed in connection with ResFil, payment information may be processed through third-party payment processors.ResFil may receive information concerning:" },
        { t: "li", s: "Subscription status" },
        { t: "li", s: "Transaction amount" },
        { t: "li", s: "Payment status" },
        { t: "li", s: "Billing history" },
        { t: "li", s: "Invoice information" },
        { t: "li", s: "Limited payment-related identifiers" },
        { t: "p", s: "We do not necessarily receive or store complete payment-card information when such information is processed directly by a payment processor." },
        { t: "li", s: "Technical and Usage Information" },
        { t: "intro", s: "When you use our website or platform, we may automatically collect certain technical information, including:" },
        { t: "li", s: "IP address" },
        { t: "li", s: "Browser type" },
        { t: "li", s: "Device type" },
        { t: "li", s: "Operating system" },
        { t: "li", s: "Pages or platform features accessed" },
        { t: "li", s: "Login activity" },
        { t: "li", s: "Session information" },
        { t: "li", s: "Error logs" },
        { t: "li", s: "Performance information" },
        { t: "li", s: "Usage information" },
        { t: "li", s: "Security-related information" },
        { t: "p", s: "We may use cookies and similar technologies where applicable." },
      ],
    },
    {
      heading: "How We Use Information",
      lines: [
        { t: "intro", s: "We may use information to:" },
        { t: "li", s: "Provide and operate the ResFil platform" },
        { t: "li", s: "Create and manage accounts" },
        { t: "li", s: "Authenticate users" },
        { t: "li", s: "Provide AI Voice Receptionist functionality" },
        { t: "li", s: "Provide AI Chat functionality" },
        { t: "li", s: "Provide AI SMS functionality" },
        { t: "li", s: "Respond to customer inquiries" },
        { t: "li", s: "Capture and manage leads" },
        { t: "li", s: "Schedule and manage appointments" },
        { t: "li", s: "Send appointment confirmations and reminders" },
        { t: "li", s: "Facilitate rescheduling and cancellations" },
        { t: "li", s: "Support customer follow-up" },
        { t: "li", s: "Support estimate or opportunity follow-up" },
        { t: "li", s: "Facilitate customer reactivation where enabled" },
        { t: "li", s: "Support no-show recovery workflows" },
        { t: "li", s: "Support review and reputation workflows" },
        { t: "li", s: "Facilitate business communication" },
        { t: "li", s: "Provide analytics and reporting" },
        { t: "li", s: "Maintain communication history" },
        { t: "li", s: "Provide call transcripts and summaries" },
        { t: "li", s: "Support dispatch and operational workflows" },
        { t: "li", s: "Integrate with authorized third-party services" },
        { t: "li", s: "Provide customer support" },
        { t: "li", s: "Maintain and improve platform reliability" },
        { t: "li", s: "Detect and prevent fraud, abuse, and security incidents" },
        { t: "li", s: "Enforce our Terms & Conditions" },
        { t: "li", s: "Comply with legal obligations" },
        { t: "li", s: "Protect ResFil, our customers, users, and others" },
        { t: "p", s: "We may also use aggregated or de-identified information for analytics, product improvement, research, and operational purposes where permitted by law." },
      ],
    },
    {
      heading: "Artificial Intelligence Processing",
      lines: [
        { t: "p", s: "ResFil uses artificial intelligence and automated technologies to provide certain Services." },
        { t: "intro", s: "Depending on the features enabled by a business, AI systems may process customer communications and business information to:" },
        { t: "li", s: "Answer calls" },
        { t: "li", s: "Respond to questions" },
        { t: "li", s: "Conduct chat conversations" },
        { t: "li", s: "Respond to text messages" },
        { t: "li", s: "Identify requested services" },
        { t: "li", s: "Capture lead information" },
        { t: "li", s: "Provide approved business information" },
        { t: "li", s: "Assist with scheduling" },
        { t: "li", s: "Assist with appointment management" },
        { t: "li", s: "Summarize communications" },
        { t: "li", s: "Categorize conversations" },
        { t: "li", s: "Facilitate follow-up" },
        { t: "li", s: "Assist with other configured business workflows" },
        { t: "p", s: "AI-generated responses may not always be error-free." },
        { t: "p", s: "Businesses using ResFil are responsible for configuring their accounts appropriately, maintaining accurate business information, and reviewing their use of automated functionality as appropriate for their operations." },
      ],
    },
    {
      heading: "Mobile Information and SMS Consent",
      lines: [
        { t: "p", s: "ResFil takes the privacy of mobile information and text-messaging consent seriously." },
        { t: "p", s: "Mobile information will not be shared, sold, rented, or disclosed to third parties or affiliates for their independent marketing or promotional purposes." },
        { t: "p", s: "Text messaging originator opt-in data and consent will not be shared with, sold to, rented to, or transferred to third parties or affiliates for their independent marketing or promotional purposes." },
        { t: "p", s: "This restriction includes information concerning an individual’s consent to receive SMS or MMS communications." },
        { t: "p", s: "Messaging consent is specific to the applicable sender and messaging program and is not treated as permission for unrelated third parties to market to the individual." },
        { t: "p", s: "We may use service providers that process mobile information as necessary to provide and support the Services, such as telecommunications providers, messaging infrastructure providers, hosting providers, security providers, and other vendors acting on our or our customers’ behalf." },
        { t: "p", s: "Such operational processing does not constitute permission for those providers to use SMS opt-in information for their own independent marketing or promotional purposes." },
        { t: "p", s: "The categories of information sharing described elsewhere in this Privacy Policy exclude text messaging originator opt-in data and consent for third-party marketing or promotional purposes." },
      ],
    },
    {
      heading: "SMS Communications",
      lines: [
        { t: "p", s: "Businesses using ResFil may use the platform to communicate with customers through SMS or MMS." },
        { t: "intro", s: "Depending on the applicable business and the consumer’s consent, messages may include:" },
        { t: "li", s: "Responses to customer inquiries" },
        { t: "li", s: "Appointment confirmations" },
        { t: "li", s: "Appointment reminders" },
        { t: "li", s: "Scheduling information" },
        { t: "li", s: "Rescheduling communications" },
        { t: "li", s: "Cancellation information" },
        { t: "li", s: "Service updates" },
        { t: "li", s: "Technician or appointment-status information" },
        { t: "li", s: "Customer support communications" },
        { t: "li", s: "Estimate or quote follow-up" },
        { t: "li", s: "Review requests" },
        { t: "li", s: "No-show recovery" },
        { t: "li", s: "Customer reactivation" },
        { t: "li", s: "Other communications authorized by the recipient and permitted by applicable law" },
        { t: "p", s: "Consent requirements may differ depending on the nature of the communication." },
        { t: "p", s: "Transactional or informational consent does not automatically constitute consent to receive unrelated marketing messages." },
        { t: "p", s: "Where required, promotional or marketing SMS consent must be separately and appropriately obtained." },
      ],
    },
    {
      heading: "SMS Opt-Out",
      lines: [
        { t: "intro", s: "Recipients may opt out of applicable recurring SMS communications by replying:" },
        { t: "p", s: "STOPAfter a valid opt-out request is processed, the recipient will no longer receive applicable messages from that sender or messaging program unless the recipient subsequently provides appropriate consent to receive messages again." },
        { t: "p", s: "Other supported opt-out keywords may include CANCEL, END, QUIT, UNSUBSCRIBE, or other keywords supported by the applicable telecommunications provider." },
        { t: "p", s: "Replying HELP may be used to obtain assistance with the applicable messaging program." },
      ],
    },
    {
      heading: "Information Sharing and Service Providers",
      lines: [
        { t: "p", s: "We may disclose information to service providers that assist us in operating ResFil." },
        { t: "intro", s: "These providers may support services such as:" },
        { t: "li", s: "Cloud hosting" },
        { t: "li", s: "Data storage" },
        { t: "li", s: "Telecommunications" },
        { t: "li", s: "Voice processing" },
        { t: "li", s: "SMS delivery" },
        { t: "li", s: "Email delivery" },
        { t: "li", s: "Payment processing" },
        { t: "li", s: "Analytics" },
        { t: "li", s: "Customer support" },
        { t: "li", s: "Security" },
        { t: "li", s: "Authentication" },
        { t: "li", s: "Calendar integrations" },
        { t: "li", s: "CRM integrations" },
        { t: "p", s: "Other infrastructure necessary to operate ResFilThese providers may process information only as appropriate for the services they provide and subject to applicable contractual and legal requirements." },
        { t: "p", s: "As stated above, mobile information and text messaging opt-in data and consent are not shared with third parties or affiliates for their independent marketing or promotional purposes." },
      ],
    },
    {
      heading: "Business Transfers",
      lines: [
        { t: "p", s: "If ResFil is involved in a merger, acquisition, financing, restructuring, sale of assets, or similar corporate transaction, information may be transferred as part of that transaction where permitted by law." },
        { t: "p", s: "Any such transaction remains subject to applicable legal requirements concerning personal information." },
        { t: "p", s: "SMS consent should not be treated as freely transferable marketing permission where applicable consent requirements prohibit such transfer." },
      ],
    },
    {
      heading: "Legal Disclosures",
      lines: [
        { t: "intro", s: "We may disclose information where reasonably necessary to:" },
        { t: "li", s: "Comply with applicable law" },
        { t: "li", s: "Respond to lawful governmental requests" },
        { t: "li", s: "Respond to subpoenas, court orders, or legal processes" },
        { t: "li", s: "Enforce agreements" },
        { t: "li", s: "Investigate fraud or abuse" },
        { t: "li", s: "Protect the security of our Services" },
        { t: "li", s: "Protect the rights, safety, or property of ResFil, our customers, users, or others" },
      ],
    },
    {
      heading: "Call Recording and Transcription",
      lines: [
        { t: "p", s: "Certain ResFil features may allow businesses to record, transcribe, summarize, or analyze telephone calls." },
        { t: "p", s: "Recording laws vary by jurisdiction." },
        { t: "p", s: "Businesses using recording functionality are responsible for determining whether notice, consent, or other requirements apply to their particular use.ResFil may process call recordings, transcripts, summaries, and associated information to provide the requested Services." },
        { t: "p", s: "The availability of recording functionality does not mean that every call made through ResFil is necessarily recorded." },
      ],
    },
    {
      heading: "Data Retention",
      lines: [
        { t: "intro", s: "We retain information for as long as reasonably necessary to:" },
        { t: "li", s: "Provide the Services" },
        { t: "li", s: "Maintain customer accounts" },
        { t: "li", s: "Fulfill contractual obligations" },
        { t: "li", s: "Maintain appropriate business records" },
        { t: "li", s: "Resolve disputes" },
        { t: "li", s: "Prevent fraud or abuse" },
        { t: "li", s: "Enforce agreements" },
        { t: "li", s: "Meet applicable legal requirements" },
        { t: "p", s: "Retention periods may vary depending on the type of information, customer configuration, contractual requirements, and applicable law." },
      ],
    },
    {
      heading: "Data Security",
      lines: [
        { t: "p", s: "ResFil uses reasonable administrative, technical, and organizational measures designed to protect information against unauthorized access, destruction, loss, alteration, or disclosure." },
        { t: "p", s: "However, no internet-based service, communications network, or information-storage system can guarantee absolute security." },
        { t: "p", s: "Users are responsible for maintaining the confidentiality of their account credentials and promptly notifying ResFil of suspected unauthorized account access." },
      ],
    },
    {
      heading: "Third-Party Integrations",
      lines: [
        { t: "p", s: "ResFil may integrate with third-party products or services, including communications, calendar, CRM, payment, or other business platforms." },
        { t: "p", s: "When a customer authorizes an integration, information may be exchanged with the applicable provider as necessary to provide the integration." },
        { t: "p", s: "Third-party services may maintain their own privacy policies and terms, and ResFil is not responsible for independent privacy practices of third parties outside ResFil’s control." },
      ],
    },
    {
      heading: "Cookies and Similar Technologies",
      lines: [
        { t: "intro", s: "ResFil may use cookies, session technologies, local storage, and similar technologies to:" },
        { t: "li", s: "Authenticate users" },
        { t: "li", s: "Maintain sessions" },
        { t: "li", s: "Remember preferences" },
        { t: "li", s: "Protect accounts" },
        { t: "li", s: "Analyze website usage" },
        { t: "li", s: "Diagnose technical problems" },
        { t: "li", s: "Improve performance" },
        { t: "p", s: "Users may be able to control certain cookie functionality through their browser settings." },
      ],
    },
    {
      heading: "Children’s Privacy",
      lines: [
        { t: "p", s: "ResFil is intended for businesses and business-related customer communications and is not designed as a service directed to children under" },
        { t: "p", s: "We do not knowingly solicit personal information directly from children under 13 through the ResFil platform." },
        { t: "p", s: "If we learn that personal information has been collected from a child in circumstances prohibited by applicable law, we will take reasonable steps to address the information appropriately." },
      ],
    },
    {
      heading: "Privacy Rights",
      lines: [
        { t: "intro", s: "Depending on where you reside, applicable law may provide rights concerning your personal information, which may include rights to:" },
        { t: "li", s: "Request access" },
        { t: "li", s: "Request correction" },
        { t: "li", s: "Request deletion" },
        { t: "li", s: "Obtain information concerning certain processing activities" },
        { t: "li", s: "Opt out of certain uses or disclosures" },
        { t: "li", s: "Appeal certain privacy decisions where applicable" },
        { t: "p", s: "Not every right applies in every jurisdiction or circumstance." },
        { t: "p", s: "Where ResFil processes information solely on behalf of a business customer, we may direct an individual to the applicable business to exercise certain rights." },
      ],
    },
    {
      heading: "Changes to This Privacy Policy",
      lines: [
        { t: "p", s: "We may update this Privacy Policy periodically." },
        { t: "p", s: "When material changes are made, we may provide notice through our website, platform, email, or another reasonable method as appropriate." },
        { t: "p", s: "The “Last Updated” date at the beginning of this Privacy Policy identifies the most recent revision." },
      ],
    },
    {
      heading: "Contact Us",
      lines: [
        { t: "p", s: "Questions regarding this Privacy Policy or ResFil’s privacy practices may be directed to ResFil AI through the contact information below." },
        { t: "li", s: "ResFil AI" },
        { t: "li", s: "5955 Alpha Rd, Ste 102 #5200, Dallas, TX 75240" },
        { t: "li", s: "Website: resfil.ai" },
        { t: "li", s: "Email: support@resfil.ai" },
      ],
    },
  ],
};

export const termsAndConditions: LegalDoc = {
  title: "ResFil AI Terms & Conditions",
  effective: "August 20, 2026",
  updated: "August 20, 2026",
  sections: [
    {
      heading: "Acceptance of Terms",
      lines: [
        { t: "p", s: "These Terms & Conditions (“Terms”) govern access to and use of the ResFil AI websites, software, applications, AI services, communication systems, and related products and services (collectively, the “Services”)." },
        { t: "p", s: "By creating an account, purchasing a subscription, accessing the platform, or otherwise using the Services, you agree to these Terms." },
        { t: "p", s: "If you use ResFil on behalf of a company or other organization, you represent that you have authority to bind that organization to these Terms." },
        { t: "p", s: "If you do not agree to these Terms, you should not use the Services." },
      ],
    },
    {
      heading: "About ResFil AI",
      lines: [
        { t: "p", s: "ResFil AI provides an AI-powered customer communication and business automation platform." },
        { t: "intro", s: "Depending on the applicable subscription plan and configuration, ResFil may provide functionality including:" },
        { t: "li", s: "AI Voice Receptionists" },
        { t: "li", s: "AI-powered SMS" },
        { t: "li", s: "AI Chat" },
        { t: "li", s: "Lead capture" },
        { t: "li", s: "Customer management" },
        { t: "li", s: "Appointment scheduling" },
        { t: "li", s: "Customer confirmations" },
        { t: "li", s: "Appointment reminders" },
        { t: "li", s: "Knowledge management" },
        { t: "li", s: "Call transcription" },
        { t: "li", s: "AI-generated call summaries" },
        { t: "li", s: "Estimate or quote follow-up" },
        { t: "li", s: "No-show recovery" },
        { t: "li", s: "Customer reactivation" },
        { t: "li", s: "Reputation/review workflows" },
        { t: "li", s: "Outbound communications" },
        { t: "li", s: "Campaigns" },
        { t: "li", s: "Dispatch-related functionality" },
        { t: "li", s: "Analytics" },
        { t: "li", s: "Revenue attribution" },
        { t: "li", s: "Multilingual AIThird-party integrations" },
        { t: "li", s: "Other business automation functionality" },
        { t: "p", s: "Available features may depend on subscription plan, configuration, geographic availability, third-party integrations, or other factors." },
      ],
    },
    {
      heading: "Eligibility",
      lines: [
        { t: "p", s: "You must have the legal capacity to enter into a binding agreement to use ResFil." },
        { t: "p", s: "If you use ResFil for a business, you represent that you are authorized to act for that business." },
      ],
    },
    {
      heading: "Accounts",
      lines: [
        { t: "p", s: "Certain Services require an account." },
        { t: "p", s: "You agree to provide accurate information and maintain current account information." },
        { t: "intro", s: "You are responsible for:" },
        { t: "li", s: "Protecting account credentials" },
        { t: "li", s: "Controlling authorized-user access" },
        { t: "li", s: "Activity occurring through authorized accounts" },
        { t: "li", s: "Promptly reporting suspected unauthorized access" },
        { t: "li", s: "Maintaining appropriate permissions for employees, contractors, and other users" },
        { t: "p", s: "You may not knowingly permit unauthorized individuals to access restricted portions of the platform." },
      ],
    },
    {
      heading: "Customer Responsibilities",
      lines: [
        { t: "p", s: "Businesses using ResFil are responsible for the accuracy and legality of information they provide to the platform." },
        { t: "intro", s: "This includes information concerning:" },
        { t: "li", s: "Services" },
        { t: "li", s: "Prices" },
        { t: "li", s: "Service areas" },
        { t: "li", s: "Business hours" },
        { t: "li", s: "Appointment availability" },
        { t: "li", s: "Policies" },
        { t: "li", s: "Knowledge Base content" },
        { t: "li", s: "Team members" },
        { t: "li", s: "Customer information" },
        { t: "li", s: "Communications" },
        { t: "li", s: "Promotional offers" },
        { t: "p", s: "Customers are responsible for ensuring that information supplied to ResFil is current and accurate." },
      ],
    },
    {
      heading: "AI-Powered Services",
      lines: [
        { t: "p", s: "ResFil uses artificial intelligence and automated systems." },
        { t: "p", s: "AI functionality may assist with customer communications, answering questions, scheduling, lead management, follow-up, and other business processes." },
        { t: "p", s: "AI-generated responses may occasionally be incomplete, inaccurate, or inappropriate for a particular situation.ResFil does not guarantee that automated systems will operate without error in every circumstance." },
        { t: "p", s: "Businesses remain responsible for configuring the Services appropriately and determining whether human review or intervention is appropriate for their operations." },
      ],
    },
    {
      heading: "Scheduling and Appointment Services",
      lines: [
        { t: "p", s: "ResFil may allow businesses and their customers to schedule, modify, confirm, or cancel appointments." },
        { t: "intro", s: "Availability presented through ResFil depends on information and integrations configured by the applicable business.ResFil does not independently guarantee:" },
        { t: "li", s: "Technician availability" },
        { t: "li", s: "Service completion" },
        { t: "li", s: "Arrival times" },
        { t: "li", s: "Appointment duration" },
        { t: "li", s: "Pricing" },
        { t: "p", s: "Service outcomesunless such information has been expressly configured and confirmed by the applicable business." },
        { t: "p", s: "The business providing the underlying service remains responsible for performing the appointment and resolving service-related disputes." },
      ],
    },
    {
      heading: "Business Pricing",
      lines: [
        { t: "p", s: "Businesses may configure prices or pricing information within ResFil." },
        { t: "p", s: "Pricing communicated by an AI agent is based on information the applicable business has authorized for disclosure.ResFil does not independently determine the price charged by third-party businesses using the platform." },
        { t: "p", s: "Businesses are responsible for maintaining accurate pricing information." },
      ],
    },
    {
      heading: "SMS/MOBILE MESSAGING TERMS",
      lines: [
        { t: "li", s: "ResFil AI Messaging Program" },
        { t: "p", s: "ResFil and businesses using ResFil may facilitate SMS/MMS communications relating to customer interactions." },
        { t: "intro", s: "Depending on the applicable business and messaging program, messages may include:" },
        { t: "li", s: "Responses to inquiries" },
        { t: "li", s: "Lead follow-up" },
        { t: "li", s: "Appointment confirmations" },
        { t: "li", s: "Appointment reminders" },
        { t: "li", s: "Scheduling" },
        { t: "li", s: "Rescheduling" },
        { t: "li", s: "Cancellations" },
        { t: "li", s: "Service updates" },
        { t: "li", s: "Customer support" },
        { t: "li", s: "Technician or appointment-status updates" },
        { t: "li", s: "Estimate or quote follow-up" },
        { t: "li", s: "Review requests" },
        { t: "li", s: "No-show recovery" },
        { t: "li", s: "Customer reactivation" },
        { t: "li", s: "Promotional communications where separately and appropriately authorized" },
        { t: "li", s: "Other communications associated with the applicable business relationship" },
        { t: "li", s: "Message Frequency" },
        { t: "p", s: "Message frequency varies." },
        { t: "p", s: "The number of messages received depends on the individual’s interactions, appointments, requests, subscriptions, and messaging preferences." },
        { t: "li", s: "Message and Data Rates" },
        { t: "p", s: "Message and data rates may apply." },
        { t: "p", s: "Your wireless carrier may charge you for SMS, MMS, or data usage according to your wireless plan." },
        { t: "li", s: "Opting Out" },
        { t: "p", s: "Reply STOP to opt out." },
        { t: "p", s: "After you send STOP, you may receive a confirmation message indicating that you have been unsubscribed. After the opt-out is processed, you will no longer receive applicable recurring messages from that sender or messaging program unless you subsequently opt in again." },
        { t: "p", s: "Other recognized opt-out keywords may be supported." },
        { t: "li", s: "Help" },
        { t: "p", s: "Reply HELP for help." },
        { t: "p", s: "You may also contact the applicable business or ResFil customer support through the contact methods provided through the relevant website or communication." },
        { t: "li", s: "Carrier Liability" },
        { t: "p", s: "Wireless carriers are not liable for delayed or undelivered messages." },
        { t: "li", s: "Privacy" },
        { t: "p", s: "Your use of SMS messaging is also subject to the ResFil AI Privacy Policy.ResFil does not sell or share SMS opt-in data or consent with third parties or affiliates for their independent marketing or promotional purposes." },
      ],
    },
    {
      heading: "SMS Consent",
      lines: [
        { t: "p", s: "Receiving promotional SMS messages is not a condition of purchasing goods or services where applicable." },
        { t: "p", s: "Consent to receive one type of communication does not necessarily constitute consent to receive another type." },
        { t: "p", s: "For example, consent to receive appointment notifications does not automatically constitute consent to receive unrelated marketing messages." },
        { t: "p", s: "Businesses using ResFil are responsible for obtaining appropriate consent before initiating communications where consent is required." },
        { t: "p", s: "Consent may not be purchased, sold, or transferred as blanket authorization for unrelated organizations to send messages." },
      ],
    },
    {
      heading: "Call Recording and Communications Compliance",
      lines: [
        { t: "p", s: "Businesses using ResFil may have access to call recording, transcription, AI analysis, or related communication features." },
        { t: "p", s: "Laws governing telephone recording, automated communications, telemarketing, SMS, consent, and customer communications vary by jurisdiction." },
        { t: "p", s: "Customers are responsible for configuring and using ResFil in compliance with laws applicable to their activities, including obtaining notices or consent where required." },
      ],
    },
    {
      heading: "Acceptable Use",
      lines: [
        { t: "intro", s: "You may not use ResFil to:" },
        { t: "li", s: "Violate applicable law" },
        { t: "li", s: "Commit fraud" },
        { t: "li", s: "Impersonate another person or business unlawfully" },
        { t: "li", s: "Send unlawful spam" },
        { t: "li", s: "Send communications without required consent" },
        { t: "li", s: "Harass or threaten individuals" },
        { t: "li", s: "Circumvent opt-out requests" },
        { t: "li", s: "Attempt unauthorized access to accounts or systems" },
        { t: "li", s: "Distribute malware" },
        { t: "li", s: "Interfere with platform security" },
        { t: "li", s: "Scrape or extract information unlawfully" },
        { t: "li", s: "Misrepresent ResFil functionality" },
        { t: "li", s: "Use the Services for unlawful or abusive purposes" },
        { t: "p", s: "ResFil may investigate suspected violations and restrict or terminate access where appropriate." },
      ],
    },
    {
      heading: "Subscriptions and Fees",
      lines: [
        { t: "p", s: "Certain ResFil Services require a paid subscription." },
        { t: "p", s: "Subscription prices, included functionality, usage allowances, and other commercial terms are displayed during the applicable purchasing or sales process." },
        { t: "p", s: "Unless otherwise stated, recurring subscriptions continue for the applicable billing period until canceled in accordance with the applicable subscription terms." },
        { t: "p", s: "Customers are responsible for applicable charges associated with their accounts." },
      ],
    },
    {
      heading: "Setup Fees",
      lines: [
        { t: "p", s: "Certain ResFil plans or services may require a one-time setup or implementation fee." },
        { t: "p", s: "A setup fee is separate from recurring subscription charges unless expressly stated otherwise." },
        { t: "p", s: "The applicable setup fee will be disclosed before purchase or included in the customer’s applicable order, checkout, proposal, or agreement." },
      ],
    },
    {
      heading: "Payment Authorization",
      lines: [
        { t: "p", s: "By providing an authorized payment method, you authorize applicable charges associated with your ResFil purchase or subscription." },
        { t: "p", s: "Recurring subscriptions may automatically renew and charge the authorized payment method at the applicable billing interval unless canceled in accordance with the applicable subscription terms." },
        { t: "p", s: "Customers are responsible for maintaining valid payment information." },
      ],
    },
    {
      heading: "Taxes",
      lines: [
        { t: "p", s: "Fees may exclude applicable taxes unless otherwise stated." },
        { t: "p", s: "Customers are responsible for taxes associated with their purchases where required by law, except taxes imposed on ResFil’s own income." },
      ],
    },
    {
      heading: "Cancellation and Refunds",
      lines: [
        { t: "p", s: "Customers may cancel subscriptions in accordance with the cancellation procedures presented through ResFil or the applicable customer agreement." },
        { t: "p", s: "Before publishing these Terms, ResFil should insert its final approved cancellation and refund policy here." },
        { t: "intro", s: "This section should specify:" },
        { t: "li", s: "When cancellation becomes effective" },
        { t: "li", s: "Whether partial-month refunds are offered" },
        { t: "li", s: "Whether setup fees are refundable" },
        { t: "li", s: "Treatment of prepaid amounts" },
        { t: "li", s: "Treatment of Custom agreements" },
        { t: "p", s: "These terms should not be invented without a final ResFil business decision." },
      ],
    },
    {
      // Supplied by ResFil and reproduced verbatim. Annual is the only interval with a settled
      // policy; the section above still awaits a decision for monthly subscriptions.
      heading: "Annual Subscription Refund Policy",
      lines: [
        { t: "p", s: "Annual subscription fees are prepaid for a 12-month service term." },
        { t: "p", s: "Requests for voluntary refunds must be submitted within 30 calendar days of the initial annual purchase." },
        { t: "p", s: "After the 30-day refund period expires, annual subscription fees are non-refundable except where otherwise required by applicable law or expressly provided in the agreement." },
      ],
    },
    {
      heading: "Third-Party Services",
      lines: [
        { t: "p", s: "ResFil may depend on or integrate with third-party services." },
        { t: "p", s: "These may include telecommunications providers, AI providers, payment processors, calendar providers, CRM platforms, email services, hosting providers, and other infrastructure.ResFil cannot guarantee uninterrupted availability of services controlled by third parties." },
        { t: "p", s: "Use of third-party products may also be subject to those providers’ terms and policies." },
      ],
    },
    {
      heading: "Customer Content and Data",
      lines: [
        { t: "p", s: "Customers may submit information, documents, Knowledge Base materials, customer information, service information, and other content to ResFil." },
        { t: "p", s: "Customers retain their rights in their content subject to the rights necessary for ResFil to process that content and provide the Services." },
        { t: "p", s: "By providing content, the customer authorizes ResFil and its service providers to host, process, transmit, and otherwise use the content as reasonably necessary to provide, secure, support, and improve the Services, subject to applicable law and agreements." },
        { t: "p", s: "Customers represent that they have appropriate rights and authority to provide such content." },
      ],
    },
    {
      heading: "ResFil Intellectual Property",
      lines: [
        { t: "p", s: "ResFil and its licensors retain all applicable rights in the ResFil platform, including software, technology, interfaces, branding, documentation, designs, systems, and related intellectual property." },
        { t: "intro", s: "Except as expressly permitted, users may not:" },
        { t: "li", s: "Copy the platform" },
        { t: "li", s: "Reverse engineer protected portions of the platform" },
        { t: "li", s: "Resell unauthorized access" },
        { t: "li", s: "Misappropriate ResFil intellectual property" },
        { t: "li", s: "Remove proprietary notices" },
        { t: "li", s: "Use ResFil trademarks without authorization" },
      ],
    },
    {
      heading: "Platform Availability",
      lines: [
        { t: "p", s: "We work to maintain reliable access to ResFil, but no software or telecommunications platform can guarantee uninterrupted operation." },
        { t: "intro", s: "Services may occasionally be unavailable because of:" },
        { t: "li", s: "Maintenance" },
        { t: "li", s: "Updates" },
        { t: "li", s: "Infrastructure failures" },
        { t: "li", s: "Telecommunications outages" },
        { t: "li", s: "Third-party provider outages" },
        { t: "li", s: "Security incidents" },
        { t: "li", s: "Events beyond reasonable control" },
        { t: "p", s: "ResFil may modify, maintain, update, or discontinue particular functionality as permitted by applicable agreements and law." },
      ],
    },
    {
      heading: "Suspension and Termination",
      lines: [
        { t: "intro", s: "ResFil may suspend or terminate access where reasonably necessary due to:" },
        { t: "li", s: "Nonpayment" },
        { t: "li", s: "Fraud" },
        { t: "li", s: "Security threats" },
        { t: "li", s: "Material violations of these Terms" },
        { t: "li", s: "Unlawful use" },
        { t: "li", s: "Abuse of communications services" },
        { t: "li", s: "Risk to ResFil or third-party infrastructure" },
        { t: "li", s: "Legal requirements" },
        { t: "p", s: "Where appropriate, we may provide notice or an opportunity to remedy the issue." },
      ],
    },
    {
      heading: "Disclaimer of Warranties",
      lines: [
        { t: "p", s: "TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, THE SERVICES ARE PROVIDED ON AN “AS IS” AND “AS AVAILABLE” BASIS." },
        { t: "p", s: "RESFIL DOES NOT WARRANT THAT THE SERVICES WILL BE UNINTERRUPTED, ERROR-FREE, OR SUITABLE FOR EVERY BUSINESS PURPOSE." },
        { t: "p", s: "AI-GENERATED OUTPUTS MAY CONTAIN ERRORS AND SHOULD NOT BE TREATED AS A SUBSTITUTE FOR PROFESSIONAL JUDGMENT WHERE SUCH JUDGMENT IS REQUIRED." },
        { t: "p", s: "Nothing in these Terms excludes warranties that cannot legally be excluded." },
      ],
    },
    {
      heading: "Limitation of Liability",
      lines: [
        { t: "p", s: "TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, RESFIL WILL NOT BE LIABLE FOR INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, PUNITIVE, OR CONSEQUENTIAL DAMAGES, INCLUDING LOST PROFITS, LOST REVENUE, LOST BUSINESS OPPORTUNITIES, OR LOSS OF DATA, ARISING FROM OR RELATING TO USE OF THE SERVICES." },
        { t: "p", s: "TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, RESFIL'S TOTAL AGGREGATE LIABILITY ARISING FROM OR RELATING TO THE SERVICES OR THESE TERMS WILL NOT EXCEED THE TOTAL FEES PAID BY THE CUSTOMER TO RESFIL IN THE TWELVE (12) MONTHS IMMEDIATELY PRECEDING THE EVENT GIVING RISE TO THE CLAIM." },
      ],
    },
    {
      heading: "Indemnification",
      lines: [
        { t: "p", s: "To the extent permitted by law and subject to any applicable customer agreement, business customers agree to indemnify and hold harmless ResFil and its applicable officers, directors, employees, and agents from third-party claims arising from the customer’s unlawful use of the Services, customer-provided content, violation of these Terms, or violation of applicable law." },
      ],
    },
    {
      heading: "Governing Law and Dispute Resolution",
      lines: [
        { t: "p", s: "These Terms are governed by the laws of the State of Delaware, without regard to its conflict-of-laws principles." },
        { t: "p", s: "Any dispute, claim, or controversy arising out of or relating to these Terms or the Services will be resolved by final and binding arbitration administered on an individual basis. The arbitration will be seated in Dallas County, Texas, and judgment on the award may be entered in any court of competent jurisdiction." },
        { t: "p", s: "TO THE EXTENT PERMITTED BY APPLICABLE LAW, YOU AND RESFIL AGREE THAT EACH MAY BRING CLAIMS AGAINST THE OTHER ONLY IN AN INDIVIDUAL CAPACITY, AND NOT AS A PLAINTIFF OR CLASS MEMBER IN ANY PURPORTED CLASS, COLLECTIVE, OR REPRESENTATIVE PROCEEDING. The arbitrator may not consolidate more than one person's claims or preside over any form of a representative or class proceeding." },
        { t: "p", s: "Nothing in this section prevents either party from seeking injunctive or equitable relief in a court of competent jurisdiction to protect its intellectual property or confidential information." },
      ],
    },
    {
      heading: "Changes to These Terms",
      lines: [
        { t: "p", s: "ResFil may update these Terms periodically." },
        { t: "p", s: "Material changes may be communicated through the platform, website, email, or another reasonable method." },
        { t: "p", s: "Continued use after updated Terms become effective may constitute acceptance where permitted by law." },
      ],
    },
    {
      heading: "Privacy Policy",
      lines: [
        { t: "p", s: "Use of ResFil is also subject to the ResFil AI Privacy Policy, available through the ResFil website." },
      ],
    },
    {
      heading: "Contact",
      lines: [
        { t: "p", s: "Questions regarding these Terms may be directed to:" },
        { t: "li", s: "ResFil AI" },
        { t: "li", s: "5955 Alpha Rd, Ste 102 #5200, Dallas, TX 75240" },
        { t: "li", s: "Website: resfil.ai" },
        { t: "li", s: "Email: support@resfil.ai" },
      ],
    },
  ],
};

